export default "__VITE_ASSET__HfhGKgWJ__"